const MIN_CAR_COST = 350000

export class PaymentCounter {
  constructor(el) {
    this.carCostEl      = el.querySelector('.js-payment-counter-car-cost')
    this.firstPaymentEl = el.querySelector('.js-payment-counter-first-payment')
    this.termEl         = el.querySelector('.js-payment-counter-term')
    this.fromEl         = el.querySelector('.js-payment-counter-from')
    this.toEl           = el.querySelector('.js-payment-counter-to')
    this.fromInputEl    = el.querySelector('.js-payment-counter-from-input')
    this.toInputEl      = el.querySelector('.js-payment-counter-to-input')
    this.resultsEl      = el.querySelector('.js-payment-counter-results')
    this.sendBtnEl      = el.querySelector('.js-payment-counter-send-btn')
    this.errorEl        = el.querySelector('.js-payment-counter-error')

    this.handleChange()
  }

  count() {
    if (
      parseInt(this.carCostEl.value) > 0 &&
      parseInt(this.termEl.value) > 0 &&
      parseInt(this.firstPaymentEl.value) >= 0
    ) {
      const monthly = (this.carCostEl.value - this.firstPaymentEl.value) / this.termEl.value / 12

      if (monthly <= 0) return false

      const fromVal = (monthly * 1.45).toFixed()
      const toVal = (monthly * 2).toFixed()

      this.fromEl.textContent = fromVal
      this.toEl.textContent = toVal

      this.fromInputEl.value = fromVal
      this.toInputEl.value = toVal

      return true
    } else {
      return false
    }
  }

  handleChange() {
    [this.carCostEl, this.firstPaymentEl, this.termEl].forEach(el =>
      el.addEventListener('keyup', () => this.countAndCheckResults())
    )
    this.countAndCheckResults()

    this.carCostEl.addEventListener('keyup', () => this.checkCost())
    this.checkCost()

    document.addEventListener('calc', () => {
      this.countAndCheckResults()
      this.checkCost()
    })
  }

  countAndCheckResults() {
    if (this.count()) {
      this.resultsEl.classList.add('active')
    } else {
      this.resultsEl.classList.remove('active')
    }
  }

  checkCost() {
    if (parseInt(this.carCostEl.value) < MIN_CAR_COST) {
      this.sendBtnEl?.classList.remove('active')
      this.errorEl?.classList.add('active')
    } else {
      this.sendBtnEl?.classList.add('active')
      this.errorEl?.classList.remove('active')
    }
  }
}
